import { CircularProgress } from '@ouster/webviz-react-components';

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

// import { useKeycloak } from '../../KeycloakContext';
import { useStoreActions, useStoreState } from '../../reducers';
import styles from '../PublicPage.module.css';

export default function PostRegistrationPage() {
  const { eulaAcceptance, registerUser } = useStoreActions(
    (actions) => actions.user
  );

  const { user } = useStoreState((storeState) => ({
    ...storeState.user,
  }));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const handlePostRegistration = async () => {
      if (!user) {
        return;
      }

      try {
        // Step 1: Get and parse registration data from local storage
        const encodedData = localStorage.getItem('registrationData');
        if (!encodedData) {
          throw new Error(
            'There are some issues completing your registration. You can try logging in, and we’ll attempt to recover your account for you.'
          );
        }

        const registrationData = JSON.parse(atob(encodedData)) as {
          country: string;
          state: string;
          eulaVersion: string;
        };
        const { country, state, eulaVersion } = registrationData;

        // Step 2: Submit EULA acceptance
        await eulaAcceptance({
          status: false,
          identity_id: user.identity_id,
          version: eulaVersion,
          country,
          state,
        });

        // Step 3: Register user and create organization
        await registerUser();

        // Step 4: Success! Clean up and navigate.
        localStorage.removeItem('registrationData');
        setIsSuccess(true);
        setIsLoading(false);

        setTimeout(() => {
          navigate('/drive');
        }, 2000);
      } catch (error) {
        const message =
          error instanceof Error ? error.message : 'An unknown error occurred.';
        setErrorMsg(
          `Failed to complete account setup: ${message}. Please try signing in or contact support with the button below.`
        );
        setIsLoading(false);
      }
    };

    handlePostRegistration();
  }, [registerUser, eulaAcceptance, user, navigate]);

  if (isLoading) {
    return (
      <div className={styles['loading-container']}>
        <CircularProgress isIndeterminate size="50px" thickness={10} />
        <p style={{ marginTop: '1rem' }}>Setting up your account...</p>
      </div>
    );
  }

  if (errorMsg) {
    return (
      <div className={styles['loading-container']}>
        <p
          style={{
            marginTop: '1rem',
            fontSize: '22px',
            color: 'var(--color-unify-error)',
            maxWidth: '700px',
            textAlign: 'center',
            textWrap: 'balance',
            lineHeight: '1.8',
          }}
        >
          {errorMsg}
        </p>
      </div>
    );
  }

  if (isSuccess) {
    return (
      <div className={styles['loading-container']}>
        <CircularProgress isIndeterminate size="50px" thickness={10} />
        <p>Your account has been created successfully.</p>
        <p>Redirecting you to the dashboard...</p>
      </div>
    );
  }

  return null;
}
